import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { getTotalCreditCount, User } from 'src/app/models/users.model';
import { NbDialogService } from '@nebular/theme';
import { AddCreditsComponent } from 'src/app/shared/ui/add-credits/add-credits.component';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ContactUsComponent } from 'src/app/shared/ui/contact-us/contact-us.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  sideNavMode = 'side';
  screenWidth: number;
  screenHeight: number;
  user: User;

  get totalCreditCount() {
    if (!this.user) {
      return null;
    }
    return getTotalCreditCount(this.user);
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    private router: Router,
    private ss: SharedService,
    private dialogService: NbDialogService,
  ) {
    this.getScreenSize();
  }

  // Add this function to get the screen size

  async ngOnInit() {
    const user = await this.ss.getUser();
    this.afs
      .doc(`users/${user.uid}`)
      .valueChanges()
      .subscribe((snap: User) => (this.user = snap));
  }

  contactUsClicked() {
    this.dialogService.open(ContactUsComponent);
  }

  addCreditsClicked() {
    this.dialogService.open(AddCreditsComponent);
  }

  onConvertClicked() {
    this.router.navigateByUrl('/home/dummy', { skipLocationChange: true });
    setTimeout(() => this.router.navigate(['home/convert']));
  }

  logoutClicked() {
    this.afAuth.signOut();
  }
}
